// extracted by mini-css-extract-plugin
export var content = "_pn-1";
export var noScroll = "_pn-3";
export var paper = "_pn-0";
export var scrollable = "_pn-2";